export default "__VITE_ASSET__CFbiDOI6__"